var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12939_308029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.9991C15.5228 19.9991 20 15.523 20 10.0015C20 4.47998 15.5228 0.00390625 10 0.00390625C4.47715 0.00390625 0 4.47998 0 10.0015C0 15.523 4.47715 19.9991 10 19.9991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2876 19.283C6.1628 18.1456 6.25 17.0587 6.5 16.009L7.5 11.6976C7.3376 11.1729 7.2124 10.5727 7.2124 9.97281C7.2124 8.57314 7.8876 7.57338 8.95 7.57338C9.6876 7.57338 10.2252 8.08566 10.2252 9.07302C10.2252 9.38535 10.1628 9.73526 10.0376 10.1352L9.6 11.5724C9.5124 11.8476 9.4752 12.1099 9.4752 12.3346C9.4752 13.3344 10.2376 13.8967 11.2128 13.8967C12.9504 13.8967 14.188 12.0971 14.188 9.76006C14.188 7.16068 12.488 5.49868 9.9756 5.49868C7.1756 5.49868 5.4008 7.32344 5.4008 9.86003C5.4008 10.8846 5.7132 11.8344 6.326 12.4842C6.126 12.8217 5.9136 12.8841 5.5884 12.8841C4.5884 12.8841 3.6384 11.472 3.6384 9.54731C3.6384 6.22291 6.3008 3.57394 10.0384 3.57394C13.9632 3.57394 16.426 6.31088 16.426 9.68488C16.426 13.0589 14.026 15.6334 11.4384 15.6334C10.4132 15.6334 9.5132 15.196 8.8884 14.4085L8.376 16.4832C8.1008 17.5578 7.6884 18.5703 7.026 19.5449C7.9636 19.8324 8.8884 19.9948 10.0012 19.9948C15.526 19.9948 20.0012 15.5207 20.0012 9.9972C20.0012 4.47373 15.5252 0 10 0C4.4748 0 0 4.47413 0 9.9976C0 14.1842 2.5752 17.7957 6.2876 19.283Z",
    fill: "#E61E27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12939_308029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIcon);
export default __webpack_public_path__ + "static/media/pinterest-icon.de4e6df70d03b7b82cd958edc5f7de58.svg";
export { ForwardRef as ReactComponent };